var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoanBasket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v20h-20z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("rect", {
    height: 15,
    rx: 2.301167,
    width: 15,
    x: 2.5,
    y: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.54583333 7.99083333h5.65083337l-.6183334 3.09083337h-4.41416663l-.8825-4.41500003h-1.10416667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.1691667 13.2583333c.0175.0175.0175.045 0 .0625s-.045.0175-.0625 0-.0175-.045 0-.0625.045-.0175.0625 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.63666667 13.2583333c.0175.0175.0175.045 0 .0625s-.045.0175-.0625 0-.0175-.045 0-.0625.04583333-.0175.0625 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanBasket);
export default __webpack_public_path__ + "static/media/loan-basket.3140ef1c5ae8e429e4a90b0096c9b926.svg";
export { ForwardRef as ReactComponent };